import React, { Component } from "react";
import PropTypes from "prop-types";
import { storeProducts, detailProduct } from "./data";

const ProductContext = React.createContext();
const ProductConsumer = ProductContext.Consumer;

class ProductProvider extends Component {
  state = {
    products: [],
    detailProduct,
    cart: [],
    modalOpen: false,
    modalProduct: detailProduct,
    cartSubTotal: 0,
    cartTax: 0,
    cartTotal: 0,
    cartCount: 0
  };

  componentDidMount() {
    // Avoid changing the value of original data
    this.setProducts();
  }

  setProducts = () => {
    let tempProducts = [];

    storeProducts.forEach(item => {
      const singleItem = { ...item };
      tempProducts = [...tempProducts, singleItem];
    });

    this.setState({
      products: tempProducts
    });
  };

  getItem = id => this.state.products.find(item => item.id === id);

  handleDetail = id => {
    const product = this.getItem(id);

    this.setState({
      detailProduct: product
    });
  };

  addToCart = id => {
    let tempProducts = [...this.state.products];
    const index = tempProducts.indexOf(this.getItem(id));
    const product = tempProducts[index];
    const price = product.price;

    product.inCart = true;
    product.count = 1;
    product.total = price;

    this.setState(
      {
        products: tempProducts,
        cart: [...this.state.cart, product],
        cartCount: this.state.cartCount + 1
      },
      () => this.addTotals()
    );
  };

  openModal = id => {
    const product = this.getItem(id);

    this.setState({
      modalProduct: product,
      modalOpen: true
    });
  };

  closeModal = () => {
    this.setState({
      modalOpen: false
    });
  };

  increment = id => {
    const tempCart = [...this.state.cart];
    const selectedProduct = tempCart.find(item => item.id === id);
    const index = tempCart.indexOf(selectedProduct);
    const product = tempCart[index];

    product.count += 1;
    product.total += product.price;

    this.setState(
      {
        cart: [...tempCart],
        cartCount: this.state.cartCount + 1
      },
      () => this.addTotals()
    );
  };

  decrement = id => {
    const tempCart = [...this.state.cart];
    const selectedProduct = tempCart.find(item => item.id === id);
    const index = tempCart.indexOf(selectedProduct);
    const product = tempCart[index];

    product.count -= 1;

    if (product.count === 0) {
      product.count += 1;

      this.removeItem(product.id);
    } else {
      product.total -= product.price;

      this.setState(
        {
          cart: [...tempCart],
          cartCount: this.state.cartCount - 1
        },
        () => this.addTotals()
      );
    }
  };

  removeItem = id => {
    let tempProducts = [...this.state.products];
    let tempCart = [...this.state.cart];

    tempCart = tempCart.filter(item => item.id !== id);

    const index = tempProducts.indexOf(this.getItem(id));
    const removeProduct = tempProducts[index];
    const { count } = removeProduct;

    removeProduct.inCart = false;
    removeProduct.count = 0;
    removeProduct.total = 0;

    this.setState(
      {
        cart: [...tempCart],
        products: [...tempProducts],
        cartCount: this.state.cartCount - count
      },
      () => {
        this.addTotals();
      }
    );
  };

  clearCart = () => {
    this.setState(
      {
        cart: [],
        cartCount: 0
      },
      () => {
        this.setProducts();
        this.addTotals();
      }
    );
  };

  addTotals = (taxRate = 0.1) => {
    let subTotal = 0;

    this.state.cart.map(item => (subTotal += item.total));

    const tempTax = subTotal * taxRate;
    const tax = parseFloat(tempTax.toFixed(2));
    const total = subTotal + tax;

    this.setState({
      cartSubTotal: subTotal,
      cartTax: tax,
      cartTotal: total
    });
  };

  render() {
    return (
      <ProductContext.Provider
        value={{
          ...this.state,
          handleDetail: this.handleDetail,
          addToCart: this.addToCart,
          openModal: this.openModal,
          closeModal: this.closeModal,
          increment: this.increment,
          decrement: this.decrement,
          removeItem: this.removeItem,
          clearCart: this.clearCart
        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}

ProductProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { ProductProvider, ProductConsumer };
